var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',_vm._b({ref:"mapRef",staticClass:"w-full h-full",attrs:{"id":"t_map"}},'div',_vm.$attrs,false)),_vm._v(" "),(_vm.loaded)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }